import {
    Box,
    IconButton,
    Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import DateTimeRangePicker from './DateTimeRangePicker';
import { useTranslation } from 'react-i18next';

function TimeRangePickerList({ entryList, onUpdateEntryList, errors, date, disabled }) {
    const {t} = useTranslation();

    const handleDelete = (index) => {
        let list = [...entryList];
        list.splice(index, 1);

        onUpdateEntryList(list);
    };

    const handleChange = (start, end, index) => {
        let list = [...entryList];
        list[index] = { start, end };
        onUpdateEntryList(list);
    };

    const addItem = () => {
        let list = [...entryList];

        if (entryList.length === 0) {
            let end = new Date(date);
            end.setMinutes(end.getMinutes() + 30);
            list.push({ start: date, end: end });
            onUpdateEntryList(list);
            return;
        };

        list.push({ start: list[list.length - 1].end, end: list[list.length - 1].end });

        onUpdateEntryList(list);
    };

    return (
        <Box>
            {entryList.map((e, index) =>
                <DateTimeRangePicker
                    start={e.start}
                    end={e.end}
                    onDelete={() => handleDelete(index)}
                    error={errors[index]}
                    onChange={(start, end) => handleChange(start, end, index)}
                    key={crypto.randomUUID()}
                    labelStart={t('start', {ns: 'dashboardPage', defaultValue : 'Start'})}
                    labelEnd={t('ende', {ns: 'dashboardPage', defaultValue : 'Ende'})}
                    disabled={disabled}
                />
            )}
            <Tooltip title={t('eintragHinzufügen', {ns : 'dashboardPage', defaultValue : 'Eintrag hinzufügen' })}>
                <IconButton 
                onClick={addItem} 
                aria-label='add-button'
                disabled={disabled}
                >
                    <AddIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default TimeRangePickerList
